export default __webpack_public_path__ + "static/media/Sume_MarcelaHeredia.08bed8bc.png";